<template>
    <div class="app">
        <jycheader
            @getGoodslist="getGoodslist"
            :navIndex="0"
        ></jycheader>
        <div class="productlist-box">
            <div class="productlist-content-box">
                <div
                    class="productlist-bannner"
                    @click="jiamengClick"
                >
                    <img
                        src="../../assets/image/img/NewRegister/jiamengbanner.png"
                        alt=""
                    >
                </div>
                <div class="productlist-content">
                    <div class="productlist-left">
                        <div class="boutique-type-box">
                            <div class="boutique-title-box">
                                <div class="boutique-type-title">精品分类</div>
                                <div class="boutique-type-subtitle">LUXURY</div>
                            </div>
                            <div class="boutique-type-nav">
                                <ul>
                                    <li
                                        v-for="(item,index) in boutiqueType"
                                        :key="index"
                                        @click="chooseType(index,item)"
                                    >
                                        <div class="boutique-nav-left">
                                            <img
                                                v-if="index!=navIndex"
                                                :src="item.img"
                                                alt=""
                                            >
                                            <img
                                                v-else
                                                :src="item.imgs"
                                                alt=""
                                            >
                                            <p :class="{typeactive:index==navIndex}">{{item.name}}</p>
                                        </div>
                                        <div
                                            class="boutique-nav-right"
                                            :class="{better:index==navIndex}"
                                        ></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="sellHot-box">
                            <div class="sellHot-top-box dis">
                                <div class="pro-linxian"></div>
                                <div
                                    class="sellHot-nav"
                                    @click="changeSellnav(index)"
                                    v-for="(item,index) in sellHotnav"
                                    :key="index"
                                >{{item}}</div>
                                <!--:class="{sellActive:sellNavindex==index}"-->
                                <!-- <div class="sellHot-nav"></div> -->
                            </div>
                            <div class="sellHot-content-box">


                                <div class="sellHot-item">
                                    <img
                                        src="../../assets/image/img/首页/sellhot_img.png"
                                        alt=""
                                    >
                                    <div class="product-title">上海崇明高山鸡毛菜现摘现发新鲜可口...</div>
                                    <div class="sellHot-infobox">
                                        <!-- <div class="sellHot-left">
                                            <div class="sellHot-left-index">1</div>
                                            <div class="sellHot-num">热销99999件</div>
                                        </div> -->
                                        <div class="sellHot-price">￥4.50元</div>
                                    </div>
                                </div>
                                <div class="sellHot-item">
                                    <img
                                        src="../../assets/image/img/首页/sellhot_img.png"
                                        alt=""
                                    >
                                    <div class="product-title">上海崇明高山鸡毛菜现摘现发新鲜可口...</div>
                                    <div class="sellHot-infobox">
                                        <!-- <div class="sellHot-left">
                                            <div class="sellHot-left-index">1</div>
                                            <div class="sellHot-num">热销99999件</div>
                                        </div> -->
                                        <div class="sellHot-price">￥4.50元</div>
                                    </div>
                                </div>





                            </div>
                        </div>
                    </div>
                    <div class="productlist-right">
                        <div class="product-list-box">
                            <div class="product-list-title">商品列表</div>
                            <div class="product-line"></div>
                            <div class="product-name-box">
                                <div class="product-name">{{typename}}：</div>
                                <div class="product-subtype">
                                    <div class="product-subtype-name">
                                        <p
                                            @click="choosebigType(index,item.id)"
                                            :class="{listactive:bigIndex==index||childId == item.id}"
                                            v-for="(item,index) in bigType"
                                            :key="index"
                                        >{{item.name}}</p>
                                    </div>
                                    <!-- <div class="product-subtype-child">
										<p v-for="(item,index) in bigType[bigIndex].children" :key="index">{{item.name}}</p>
									</div> -->
                                </div>
                            </div>
                            <div class="product-line"></div>
                            <div class="product-name-box">
                                <div class="product-name">类别：</div>
                                <div class="product-subtype betters">
                                    <div
                                        class="product-subtype-name"
                                        v-if="bigType[bigIndex]"
                                    >
                                        <p
                                            @click="choosesmallType(index,item.id,item.parentId)"
                                            :class="{listactive:smallIndex==index}"
                                            v-for="(item,index) in bigType[bigIndex].children"
                                            :key="index"
                                        >
                                            {{item.name}}
                                        </p>
                                    </div>
                                    <!-- <div class="type-better">更多<span></span></div> -->
                                </div>
                            </div>
                            <!-- <div class="product-name-box weight">
								<div class="product-name">重量：</div>
								<div class="product-subtype">
									<div class="product-subtype-name">
										<p @click="chooseweightType(index)" :class="{listactive:weightIndex==index}"
											v-for="(item,index) in weightTypedata" :key="index">{{item}}</p>
									</div>
								</div>
							</div> -->
                        </div>
                        <div class="product-showbox">
                            <div class="product-paixu dis-between">
                                <div class="dis product-p2">
                                    <div>排序：</div>
                                    <div
                                        class="product-jian"
                                        :class="is_update?'prod-act':''"
                                        @click="sortClick(1)"
                                    >更新时间</div>
                                    <div
                                        class="product-jian"
                                        :class="is_sales?'prod-act':''"
                                        @click="sortClick(2)"
                                    >销量</div>
                                    <div
                                        class="product-jian"
                                        :class="is_price?'prod-act':''"
                                        @click="sortClick(3)"
                                    >价格</div>
                                    <div
                                        class="product-jian"
                                        :class="is_dateIssued?'prod-act':''"
                                        @click="sortClick(4)"
                                    >上架时间</div>
                                </div>
                                <div class="product-p">
                                    共{{totalLength}}商品
                                </div>
                            </div>
                            <!--旧版备份-->
                            <!-- <div class="product-show-header">
                                <div class="product-header-leftbox">
                                    <p>首页</p><img
                                        src="../../assets/image/iocn/shownetter.png"
                                        alt=""
                                    >
                                    <div class="bigTypebox">
                                        <el-select
                                            v-model="bigTypeselect"
                                            @change="firstType"
                                            placeholder="请选择"
                                        >
                                            <el-option
                                                v-for="(item,index) in bigOptions"
                                                :key="index"
                                                :label="item.name"
                                                :value="index"
                                            >
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <img
                                        src="../../assets/image/iocn/shownetter.png"
                                        alt=""
                                    >
                                    <div class="bigTypebox">
                                        <el-select
                                            v-model="smallTypeselect"
                                            placeholder="请选择"
                                            @change="secondType"
                                        >
                                            <el-option
                                                v-for="(item,index) in smallOptions"
                                                :key="index"
                                                :label="item.name"
                                                :value="index"
                                            >
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <img
                                        src="../../assets/image/iocn/shownetter.png"
                                        alt=""
                                    >
                                    <div class="bigTypebox subselect">
                                        <span>类别:</span>
                                        <el-select
                                            clearable
                                            v-model="subTypeselect"
                                            placeholder="请选择"
                                            @change="childType"
                                        >
                                            <el-option
                                                v-for="(item,index) in subOptions"
                                                :key="index"
                                                :label="item.name"
                                                :value="index"
                                            >
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="product-header-rightbox">
                                    <p class="product-num">共{{totalLength}}件商品</p>
                                    <p class="product-page"><span>{{nowPage}}</span>/{{totalPage}}</p>
                                    <div class="changepage-box">
                                        <div
                                            class="changepage-pre"
                                            @click="prePage"
                                            :class="{changeactive:pageIndex==0}"
                                        ><span></span></div>
                                        <div
                                            class="changepage-next"
                                            @click="nextPage"
                                            :class="{changeactive:pageIndex==1}"
                                        ><span></span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="choose-type-box">
                                <div
                                    class="alltype"
                                    @click="allType"
                                    :class="{chooseActice:allTypeindex==true}"
                                >综合
                                    <img
                                        v-if="allTypeindex==false"
                                        src="../../assets/image/img/首页/sort-imgs.png"
                                        alt=""
                                    >
                                    <img
                                        v-else
                                        src="../../assets/image/iocn/choose_sort.png"
                                        alt=""
                                    >
                                </div>
                                <div
                                    class="sellNum"
                                    @click="sellNum"
                                    :class="{chooseActice:sellNumindex==true}"
                                >销量
                                    <img
                                        v-if="sellNumindex==false"
                                        src="../../assets/image/img/首页/sort-imgs.png"
                                        alt=""
                                    >
                                    <img
                                        v-else
                                        src="../../assets/image/iocn/choose_sort.png"
                                        alt=""
                                    >
                                </div>
                                <div
                                    class="sellPrice"
                                    @click="sellPrice"
                                    :class="{chooseActice:sellPriceindex==true}"
                                >
                                    价格
                                    <img
                                        v-if="sellPriceindex==false"
                                        src="../../assets/image/img/首页/sort-imgs.png"
                                        alt=""
                                    >
                                    <img
                                        v-else
                                        src="../../assets/image/iocn/choose_sort.png"
                                        alt=""
                                    >
                                </div>
                                <div
                                    class="sellNewproduct"
                                    @click="sellNews"
                                    :class="{chooseActice:sellNewproduct==true}"
                                >新品
                                    <img
                                        v-if="sellNewproduct==false"
                                        src="../../assets/image/img/首页/sort-imgs.png"
                                        alt=""
                                    >
                                    <img
                                        v-else
                                        src="../../assets/image/iocn/choose_sort.png"
                                        alt=""
                                    >
                                </div>
                            </div> -->
                            <!--旧版，末尾-->

                            <div class="showproduct-box">
                                <div
                                    class="product-item marketlistbut2"
                                    v-for="(item,index) in showlistData"
                                    :key="index"
                                >
                                    <div>
                                        <div style="text-align: center;width:100%">
                                            <img
                                                :src="item.cover"
                                                alt=""
                                                class="product-img"
                                                @click="product_detail(item.id)"
                                            >
                                        </div>
                                        <div class="dis-end">
                                            <div
                                                class="product-guangzhu product-operat"
                                                style="cursor:pointer"
                                                v-if="!item.is_attention"
                                                @click="attention(index,item.is_attention,item.id,item.categoryId)"
                                            >
                                                <!--v-if="rSelect.indexOf(index)==-1&&!item.is_attention"-->
                                                <img
                                                    src="../../assets/image/iocn/save_no.png"
                                                    alt=""
                                                >
                                                关注
                                            </div>

                                            <div
                                                class="product-guangzhu product-operat"
                                                style="color:#ED0000;background-color: #ffffff;cursor:pointer"
                                                v-else
                                                @click="attention(index,item.is_attention,item.id,item.categoryId)"
                                            >
                                                <img
                                                    src="../../assets/image/iocn/saves.png"
                                                    alt=""
                                                >
                                                已关注
                                            </div>
                                        </div>
                                        <div class="dis-cen">
                                            <div class="dis">
                                                <!-- <p>{{item.name}}</p> -->
                                                <div style="margin:4px 5px 0 0">{{item.name}}</div>
                                                <!-- <div v-if="item.goodsSize" class="good-size-p2">{{item.goodsSize}}</div><div v-else class="good-size-p2" style="color:#ffffff">1</div> -->
                                                <div class="all-com-p" style="margin-top:8px">
                                                    <span v-if="item.goodsComponent1">({{item.goodsComponent1}})</span>
                                                    <span v-if="item.goodsComponent1 && item.goodsSize"> / </span>
                                                    <span v-if="item.goodsSize">{{item.goodsSize}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width:100%">
                                        <div class="dis-between product-pad">
                                            <div>
                                                <div
                                                    class="discount-price"
                                                    style="color: #ED0000;font-size: 15px;"
                                                >¥&nbsp;<span>{{item.price}}</span>元</div>
                                                <!-- <div class="discount-price">抢购价：<span>{{item.price}}元/斤</span></div>
                                                <div class="original-Price">原价：{{item.discountPrice}}元</div> -->
                                                <div class="product-yishou">已售：{{item.salesSum}}</div>
                                            </div>

                                            <div
                                                class="buycar-img-box"
                                                v-if="item.isAddCar"
                                                @click="join_shopcart(index, item.id, 2, item.categoryType, item.shopId)"
                                            >
                                                <img class="buycar-img" src="../../assets/image/iocn/jiaru2.png" alt="">
                                            </div>
                                            <div
                                                class="buycar-img-box"
                                                v-else
                                                @click="join_shopcart(index, item.id, 1, item.categoryType, item.shopId)"
                                            >
                                                <img class="buycar-img" src="../../assets/image/iocn/jiaru.png" alt="" >
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="list-page dis-end">
                                <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[100, 200, 300, 400]"
                                    :page-size="pageSize"
                                    layout="total, prev, pager, next, jumper"
                                    :total="totalLength"
                                >
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <jycfooter></jycfooter>
    </div>

</template>

<script>
    import jycheader from "../header.vue"
    import jycfooter from "../bottom.vue"
    import falseData from "../../api/data.js"
    const token = localStorage.getItem( 'token' );

    export default
    {
        data()
        {
            return {
                productName: '',
                totalPage: 0, //总页数
                rSelect: [],
                isSave: true,
                pageNo: 1,
                secondtypeId: null, //二级分类id
                pageSize: 20,
                totalLength: 0, //总条数
                childtypeId: null, //三级级分类id
                smalltypeId: 0,
                bigtypeId: 0,
                typename: '',
                currentPage: 1,
                saveflag: false, //关注状态
                allTypeindex: false, //综合
                sellNumindex: false, //销量
                sellPriceindex: false, //价格
                sellNewproduct: false, //新品
                nowPage: 1, //当前页数
                productPage: 10, //总页数
                pageIndex: 0, //页数索引
                bigOptions: [],
                bigTypeselect: '',
                smallOptions: [],
                subOptions: [],
                weightIndex: 0,
                smallTypeselect: '',
                subTypeselect: '',
                bigIndex: 0,
                smallIndex: -1,
                weightTypedata: [],
                smallType: [],
                bigType: [],
                subTypedata: [],
                // sellHotnav: [ "热销产品", "热门关注" ],
                sellHotnav: [ "销量排行", "" ],
                navIndex: 0,
                sellNavindex: 0,
                showlistData: [],
                boutiqueType: [],
                childId: 0,
                // +------------------------------------------
                saveListId: [],
                is_update: false,
                is_sales: false,
                is_price: false,
                is_dateIssued: false
            }
        },
        created()
        {
            window.scroll(0, 0)
            this.$loading();
            // this.getSaveList()

        },
        watch:
        {
            async "$route"()
            {
                // 三级分类id
                let categoryId = this.$route.query.categoryId;
                // 二级分类id
                let twoCategoryId = this.$route.query.twoCategoryId;
                this.setAction( this.boutiqueType, twoCategoryId, categoryId );
                this.getGoodslist( categoryId, twoCategoryId );
            }
        },
        mounted()
        {
            // 三级分类id
            let categoryId = this.$route.query.categoryId;
            // 二级分类id
            let twoCategoryId = this.$route.query.twoCategoryId;
            let type = this.$route.query.type;
            let name = this.$route.query.name;
            if ( type != 1 )
            {
                if ( this.smallIndex != -1 )
                {
                    this.childtypeId = categoryId;
                }
                this.secondtypeId = twoCategoryId;
            }
            else
            {
                this.secondtypeId = null;
                this.productName = name;
            }
            this.getTypeList( categoryId, twoCategoryId );
            this.getGoodslist( categoryId, twoCategoryId );
        },
        methods:
        {
            sortClick( val )
            {
                if ( val == 1 )
                {
                    this.is_update = !this.is_update
                }
                else if ( val == 2 )
                {
                    this.is_sales = !this.is_sales
                }
                else if ( val == 3 )
                {
                    this.is_price = !this.is_price
                }
                else if ( val == 4 )
                {
                    this.is_dateIssued = !this.is_dateIssued
                }
                // ??? 拉取列表请求接口


            },
            getSaveList()
            { //获取关注列表数据
                let tokenValue = localStorage.getItem( 'token' )
                if ( tokenValue == '' || tokenValue == null )
                {
                    // ...
                }
                else
                {

                    this.$loading();
                    let params = {
                        PageNo: 1,
                        PageSize: 300,
                        Params:
                        {
                            CategoryId: null //备用 选填
                        }
                    }
                    this.$api.product.saveList( params ).then( res =>
                    {
                        this.$loading().close();
                        if ( res.data.code == 0 )
                        {
                            const { data } = res.data.result;
                            for ( let i = 0; i < data.length; i++ )
                            {
                                this.saveListId.push( data[ i ].goodsId )
                            }
                        }
                        else
                        {
                            let name = res.data.message;
                            this.checkTips( name, 'warning' );
                        }
                    } )
                }
            },
            jiamengClick()
            {
                this.$router.push( { path: "/join" } )
            },
            // +-----------------------------------------
            getGoodslist( categoryId, twoCategoryId )
            {
                let cityname = JSON.parse( localStorage.getItem( 'cityname' ) )
                //获取产品列表
                let params = {
                    PageNo: this.pageNo,
                    PageSize: this.pageSize,
                    Params:
                    {
                        TwoCategoryId: parseInt( twoCategoryId ), //必填
                        CategoryId: parseInt( categoryId ), //第三级分类(不选传unll)
                        PriceDesc: false, //价格是否倒序(选填 不排序就传unll)
                        TimeDesc: false, //最新是否倒序(选填 不要就传unll)
                        Name: this.productName,
                        regionId: cityname.threeId > 0?cityname.threeId: null,
                        cityId: cityname.twoId,
                    }
                }
                this.$api.product.goodsList( params ).then( res =>
                {
                    this.$loading().close();
                    // console.log(res.data.result);

                    // let saveIdData = this.saveListId
                    let showData = res.data.result.data
                    for ( let i = 0; i < showData.length; i++ )
                    {
                        let id = showData[ i ].id
                        showData[ i ][ 'is_attention' ] = showData[ i ][ 'isAttention' ]

                        // !!! 以下步骤作为数据的校对
                        // for ( let j = 0; j < saveIdData.length; j++ )
                        // {
                        //     console.log( id )
                        //     console.log( saveIdData[ j ] )
                        //     if ( id == saveIdData[ j ] )
                        //     {
                        //         showData[ i ].is_attention = true
                        //         console.log( '12345s4d5d4sd' );
                        //     }
                        // }
                    }

                    this.showlistData = showData;
                    console.log( this.showlistData )

                    // +---------------------------------------

                    let totalcount = res.data.result.totalCount;
                    this.totalLength = totalcount;
                    // 计算一共有几页
                    this.totalPage = Math.ceil( totalcount / this.pageSize );
                    // 计算得0时设置为1
                    this.totalPage = this.totalPage == 0 ? 1 : this.totalPage;
                } )
            },
            childType( index )
            {
                let childId = this.subOptions[ index ].id;
                this.childtypeId = childId;
                this.pageNo = 1;
                this.getGoodslist( childId, this.secondtypeId );
            },
            secondType( index )
            {
                this.subOptions = this.smallOptions[ index ].children;
                let secondId = this.smallOptions[ index ].id;
                this.secondtypeId = secondId;
                this.childtypeId = null;
                this.pageNo = 1;
                this.getGoodslist( null, secondId );
            },
            firstType( index )
            {
                // console.log(index)
                this.smallOptions = this.bigOptions[ index ].children;
            },
            getTypeList( categoryId, twoCategoryId )
            { //获取精品分类列表
                this.$api.product.productType().then( res =>
                {
                    // console.log(res.data)
                    if ( res.data.code == 0 )
                    {
                        let data = res.data.result;
                        this.boutiqueType = data;
                        this.typename = data[ 0 ].name;
                        this.bigType = data[ 0 ].children;
                        // console.log(data[0].children)
                        this.bigOptions = data;
                        let smalldata = data[ 0 ].children;
                        // this.smallType = smalldata[this.bigIndex].children;
                        this.setAction( data, twoCategoryId, categoryId );
                    }

                } )
            },
            setAction( data, twoCategoryId, categoryId )
            {

                data.forEach( ( element, index ) =>
                {
                    element.children.forEach( ( two, i ) =>
                    {
                        console.log( two.id == twoCategoryId )
                        if ( two.id == twoCategoryId )
                        {
                            two.children.forEach( ( item, j ) =>
                            {
                                if ( item.id == categoryId )
                                {
                                    this.navIndex = index;
                                    this.bigIndex = i;
                                    this.smallIndex = j;
                                    this.bigType = data[ index ].children;
                                }
                            } )
                        }
                    } )
                } );
            },
            product_detail( id )
            {
                this.$router.push(
                {
                    path: "/details",
                    query:
                    {
                        id: id
                    }
                } )
            },
            handleSizeChange( val )
            {
                console.log( `每页 ${val} 条` );
            },
            handleCurrentChange( val )
            {
                this.pageNo = val;
                this.getGoodslist( this.childtypeId, this.secondtypeId );
                console.log( `当前页: ${val}` );
            },
            join_shopcart( idx, id, val, categoryType, shopId )
            { //点击实现加入购物车
                // if ( token == '' || token == undefined || token == null )
                if ( !localStorage.getItem( 'token' ) )
                {
                    this.$message(
                    {
                        message: "登录后才可以加入购物车成功!",
                        type: "warning"
                    } )
                }
                else if ( val == 2 )
                {
                    this.$message(
                    {
                        message: "该商品已经在购物车内",
                        type: "warning"
                    } )
                }
                else
                {
                    this.$loading();
                    let params = {
                        ShopProductId: id,
                        CategoryType: categoryType,
                        Num: 1,
                        ShopId: shopId
                    }
                    this.$api.product.joinshopCart( params ).then( res =>
                    {
                        this.$loading().close();
                        // console.log(res)
                        if ( res.data.code == 0 )
                        {
                            this.$message(
                            {
                                message: '加入购物车成功!',
                                type: "success"
                            } )
                            this.showlistData[ idx ].isAddCar = true
                        }
                        else
                        {
                            this.$message(
                            {
                                message: res.data.message,
                                type: "warning"
                            } )
                        }
                    } )
                }
            },
            attention( index, flag, goodId, categoryId )
            { //点击关注
                // if ( token == '' || token == undefined || token == null )
                if ( !localStorage.getItem( 'token' ) )
                {
                    this.$message(
                    {
                        message: "登录后才可以点击关注!",
                        type: "warning"
                    } )
                }
                else
                {
                    // 新代码 +-----------------------------------------------
                    let params = {
                        ShopGoodId: goodId,
                        CategoryId: categoryId
                    }
                    this.$api.product.clickSave( params ).then( res =>
                    {
                        console.log( res );
                        if ( res.data.code == 0 )
                        {
                            if ( flag )
                            {
                                this.showlistData[ index ].is_attention = false
                            }
                            else
                            {
                                this.showlistData[ index ].is_attention = true
                            }

                        }
                        else
                        {
                            this.$message(
                            {
                                message: res.data.message,
                                type: 'warning'
                            } )
                        }
                    } )



                    // 旧代码 +-------------------------------------------
                    // if ( this.rSelect.indexOf( index ) == -1 )
                    // {
                    //     let params = {
                    //         ShopGoodId: goodId,
                    //         CategoryId: categoryId
                    //     }
                    //     this.$api.product.clickSave( params ).then( res =>
                    //     {
                    //         console.log( res );
                    //         if ( res.data.code == 0 )
                    //         {
                    //             this.rSelect.push( index )
                    //         }
                    //         else
                    //         {
                    //             this.$message(
                    //             {
                    //                 message: res.data.message,
                    //                 type: 'warning'
                    //             } )
                    //         }
                    //     } )
                    // }
                    // else
                    // {
                    //     let params = {
                    //         ShopGoodId: goodId,
                    //         CategoryId: categoryId
                    //     }
                    //     this.$api.product.clickSave( params ).then( res =>
                    //     {
                    //         // console.log(res);
                    //         if ( res.data.code == 0 )
                    //         {
                    //             this.rSelect.splice( this.rSelect.indexOf( index ), 1 );
                    //         }
                    //         else
                    //         {
                    //             this.$message(
                    //             {
                    //                 message: res.data.message,
                    //                 type: 'warning'
                    //             } )
                    //         }
                    //     } )
                    // }
                }
            },
            sellNews()
            { //新品
                this.sellNewproduct = !this.sellNewproduct;
            },
            sellPrice()
            { //价格筛选
                this.sellPriceindex = !this.sellPriceindex;
            },
            sellNum()
            { //销量筛选
                this.sellNumindex = !this.sellNumindex;
            },
            allType()
            { //综合筛选
                this.allTypeindex = !this.allTypeindex;
            },
            nextPage()
            { //点击下一页
                if ( this.nowPage < this.totalPage )
                {
                    this.pageIndex = 1;
                    this.nowPage++;
                    this.pageNo = this.nowPage;
                    this.getGoodslist( this.childtypeId, this.secondtypeId );
                }
            },
            prePage()
            { //点击上一页
                if ( this.nowPage <= this.totalPage && this.nowPage > 1 )
                {
                    this.pageIndex = 0;
                    this.nowPage--;
                    this.pageNo = this.nowPage;
                    this.getGoodslist( this.childtypeId, this.secondtypeId );
                }
            },
            choosebigType( index, id )
            { //选择大类
                this.childId = 0;
                this.bigIndex = index;
                this.bigtypeId = index;
                this.secondtypeId = id;
                this.pageNo = 1;
                this.childtypeId = null;
                this.smallIndex = -1;
                this.getGoodslist( null, id )
            },
            choosesmallType( index, id, parentId )
            { //选择小类
                this.smallIndex = index;
                // this.smalltypeId = id;
                this.pageNo = 1;
                this.childtypeId = id;
                this.getGoodslist( id, parentId )
                this.childId = parentId;
            },
            changeSellnav( index )
            { //热销产品切换
                this.sellNavindex = index;
            },
            chooseType( index, data )
            { //精品分类切换
                this.navIndex = index;
                this.typename = data.name;
                this.bigType = data.children;
                this.smallIndex = -1;
                this.bigIndex = 0;
            }
        },
        components:
        {
            jycheader,
            jycfooter
        }
    }
</script>

<style scoped="scoped">
    .list-page {
        width: 100%;
        height: 2.125rem;
        margin-top: 2.5rem;
        text-align: center;
    }

    .join-shopcart img {
        margin-right: 5px;
    }

    .join-shopcart {
        width: 6.125rem;
        background-color: #069338;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .save-product {
        width: 4rem;
        background-color: #B2B2B2;
        cursor: pointer;
    }

    .product-operat {
        /* width: 10.625rem;
        text-align: center; */
        /* margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center; */
        color: #ffffff;
        font-size: 12px;
        font-weight: 400;
        background-color: #929292;
        border-radius: 5px;
        padding: 0 4px;
        height: 20px;
        line-height: 19px;
    }

    .original-Price {
        color: #999999;
        font-size: 12px;
        font-weight: 400;
        line-height: 34px;
        text-decoration: line-through;
    }

    .discount-price span {
        color: #ED0000;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 34px;
    }

    .discount-price {
        color: #999999;
        font-size: 12px;
        font-weight: 400;
        /* margin-top: 1.1875rem; */
        /* line-height: 34px; */
    }

    .product-item p {
        width: 100%;
        text-align: center;
        /* margin-top: 1.25rem; */
        font-size: 14px;
        color: #333333;
        font-weight: 400;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-family: Microsoft YaHei;
        line-height: 34px;
    }

    .product-item {
        /* text-align: center; */
        width: 220px;
        height: 320px;
        /* padding-top: 1.875rem; */
        margin: 0 4px;
        background-color: #ffffff;
        margin-bottom: 17px;
        border-radius: 12px;
    }

    .showproduct-box {
        width: 100%;
        height: auto;
        padding: 0 4px;
        display: flex;
        /* justify-content: space-between; */
        flex-wrap: wrap;
        margin-top: 1.25rem;
    }

    .chooseActice {
        color: #FFFFFF !important;
        background-color: #E4393C;
    }

    .choose-type-box img {
        margin-left: 5px;
    }

    .choose-type-box div:nth-of-type(1),
    .choose-type-box div:nth-of-type(2),
    .choose-type-box div:nth-of-type(3) {
        border-right: none;
    }

    .choose-type-box div {
        width: 25%;
        text-align: center;
        line-height: 1.5rem;
        border: 1px solid #B3B3B3;
        cursor: pointer;
    }

    .choose-type-box {
        width: 14.5rem;
        display: flex;
        height: 1.75rem;
        justify-content: center;
        color: #191919;
        font-size: 14px;
        font-weight: 500;
        margin-top: 0.625rem;
        margin-left: 0.875rem;
    }

    .changeactive {
        background-color: #E6E6E6;
    }

    .changepage-next span {
        transform: rotate(45deg) !important;
    }

    .changepage-pre span,
    .changepage-next span {
        display: inline-block;
        width: 0.625rem;
        height: 0.625rem;
        border-top: 2px solid #6C6666;
        border-right: 2px solid #6C6666;
        transform: rotate(-135deg);
    }

    .changepage-pre,
    .changepage-next {
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .changepage-box {
        width: 5.875rem;
        height: 1.5rem;
        border: 1px solid #E6E6E6;
        display: flex;
    }

    .product-num,
    .product-page {
        margin-right: 0.625rem;
    }

    .product-header-rightbox span {
        color: #C80000;
    }

    .product-header-rightbox {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #6C6666;
        font-size: 14px;
        font-weight: 400;
    }

    .subselect {
        width: 8.875rem;
        border: 1px solid #999999;
        display: flex;
        padding-left: 6px;
    }

    .bigTypebox span {
        color: #6C6666;
        font-size: 14px;
    }

    .product-header-leftbox img {
        margin: 0 0.625rem;
    }

    .product-header-leftbox {
        display: flex;
        align-items: center;
        color: #6C6666;
        font-size: 14px;
        font-weight: 400;
    }

    .product-show-header {
        width: 100%;
        height: 3.125rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.625rem 0 0.875rem;
        border-bottom: 1px solid #F2F2F2;
    }

    .weight {
        margin-top: 2.5rem;
    }

    .type-better span {
        display: inline-block;
        width: 0.375rem;
        height: 0.375rem;
        border-top: 1px solid #E7E7E7;
        border-right: 1px solid #E7E7E7;
        transform: rotate(135deg);
        margin-left: 5px;
    }

    .betters {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .type-better {
        color: #989898;
        font-weight: 400;
        font-size: 12px;
        width: 3rem;
        height: 1.5rem;
        line-height: 1.5rem;
        padding: 0 4px;
        border: 1px solid #999999;
        margin-right: 1.25rem;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .listactive {
        color: #FFFFFF !important;
        background-color: #069338;
        border-radius: 12px;
    }

    .product-subtype-child p {}

    .product-subtype-child {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 0.625rem;
    }

    .product-subtype-name p,
    .product-subtype-child p {
        font-size: 14px;
        height: 1.5rem;
        line-height: 1.5rem;
        color: #666666;
        font-weight: 400;
        /* margin-right: 1.25rem; */
        cursor: pointer;
        padding: 0 0.625rem;
    }

    .product-subtype-name {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .product-subtype {
        width: 100%;
        margin-left: 0.625rem;
    }

    .product-name {
        width: auto;
        color: #333333;
        font-size: 16px;
        font-weight: 400;
        min-width: 5rem;
        text-align: right;
    }

    .product-name-box {
        display: flex;
        padding-left: 1rem;
    }

    .sellHot-price {
        color: #C30000;
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 21px
    }

    .sellHot-num {
        color: #9A9A9A;
        font-size: 16px;
        font-weight: 400;
    }

    .sellHot-left-index {
        margin-right: 4px;
        border-radius: 50%;
        color: #FFFFFF;
        background-color: #E4393C;
        width: 1.625rem;
        height: 1.625rem;
        line-height: 1.625rem;
        text-align: center;
        font-size: 22px;
        font-weight: 400;
    }

    .sellHot-left {
        display: flex;
        align-items: center;
    }

    .sellHot-infobox {
        padding: 0 1.5rem 0 0.75rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 1.625rem;
    }

    .sellHot-item img {
        width: 100%;
        height: auto;
    }

    .sellHot-item {
        width: 70%;
        margin: 0 15%;
        height: auto;
        /* text-align: center; */
        padding-top: 1.875rem;
        border-bottom: 1px solid #f1f1f1
    }

    .product-line {
        width: 100%;
        border-top: 1px dashed #CFCFCF;
        margin: 1.25rem 0;
    }

    .product-list-title {
        font-size: 16px;
        color: #069338;
        font-weight: 400;
        padding-left: 1rem;
    }

    .product-list-box {
        padding: 1.5rem 1.625rem;
    }

    .sellActive {
        background-color: #E4393C;
        color: #FFFFFF !important;
    }

    .sellHot-nav {
        /* width: 50%; */
        height: 100%;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        text-align: center;
        color: #434343;
        line-height: 42px;
        cursor: pointer;
    }

    .sellHot-top-box {
        width: 100%;
        /* height: 3.125rem; */
        height: 42px;
        background-color: #F7F7F7;
        display: flex;
        /* border-bottom: 1px solid #E4393C;
        margin-bottom: 1.25rem; */
    }

    .boutique-type-nav li:nth-last-of-type(1) {
        border: none;
    }

    .boutique-nav-left>p {
        font-weight: 400;
        font-size: 16px;
    }

    .boutique-nav-left img {
        margin-right: 0.875rem;
    }

    .typeactive {
        color: #37A115;
    }

    .better {
        border-color: #37A115 !important;
    }

    .boutique-nav-right {
        width: 0.75rem;
        height: 0.75rem;
        border-top: 3px solid #E7E7E7;
        border-right: 3px solid #E7E7E7;
        transform: rotate(45deg);
    }

    .boutique-nav-left {
        display: flex;
        align-items: center;
    }

    .boutique-type-nav li {
        width: 100%;
        height: 3.0625rem;
        color: #333333;
        font-size: 16px;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1.75rem 0 1.375rem;
        /* border-bottom: 1px solid #E7E7E7; */
        cursor: pointer;
    }

    .boutique-type-nav {
        width: 100%;
        height: auto;
    }

    .boutique-type-subtitle {
        color: #999999;
        font-size: 12px;
        font-weight: bold;
    }

    .boutique-type-title {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        margin-right: 0.75rem;
    }

    .boutique-title-box {
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        padding: 1.25rem 0 0 1.375rem;
        margin-bottom: 1rem;
    }

    .product-showbox {
        width: 100%;
        height: auto;
        min-height: 34.375rem;
        /* background-color: #FFFFFF; */
        margin-top: 1rem;
        padding-bottom: 2.125rem;
    }

    .sellHot-box {
        width: 100%;
        height: auto;
        min-height: 49.25rem;
        background-color: #FFFFFF;
        margin-top: 1rem;
        padding-bottom: 2.5rem;
    }

    .product-list-box {
        width: 100%;
        height: auto;
        min-height: 322px;
        background-color: #FFFFFF;

    }

    .boutique-type-box {
        height: auto;
        width: 100%;
        background-color: #FFFFFF;
        padding: 0 0 15px 0
    }

    .productlist-right {
        width: 57.5rem;
    }

    .productlist-left {
        width: 16.75rem;
    }

    .productlist-content {
        display: flex;
        justify-content: space-between;
        margin-top: 0.875rem;
    }

    .productlist-bannner,
    .productlist-bannner img {
        width: 75rem;
        height: 400px;
    }

    .productlist-content-box {
        width: 75rem;
        height: auto;
        margin: auto;
    }

    .productlist-box {
        width: 100%;
        height: auto;
        padding: 0.75rem 0 3.625rem 0;
        background-color: #F2F2F2;
        /* margin-bottom: 23.375rem; */
    }
</style>
<style>
    .list-page .el-pagination__jump {
        color: #97989D;
    }

    .list-page .btn-prev,
    .list-page .el-pagination__total,
    .list-page .el-pagination span:not([class*=suffix]) {
        height: 2.125rem;
        line-height: 2.125rem;
    }

    .list-page .el-pagination__editor {
        height: 2.125rem;
    }

    .list-page .el-input__inner,
    .list-page .el-pagination__total {
        color: #97989D;
    }

    .list-page .btn-next {
        padding-left: 4px;
    }

    .list-page .el-pagination button:hover {
        color: #97989D;
    }

    .list-page .btn-prev,
    .list-page .btn-next {
        width: 2.125rem;
        border: 1px solid #E3E3E3;
        border-radius: 5px;
        padding-right: 4px;
        margin-right: 5px;
        height: 2.125rem;
        line-height: 2.125rem;
    }

    .list-page .el-pager li.active+li {
        border-left: 1px solid #E3E3E3;
    }

    .list-page .el-pager li {
        width: 2.125rem;
        height: 2.125rem;
        line-height: 2.125rem;
        color: #97989D;
        font-size: 12px;
        background: #FFFFFF;
        border: 1px solid #E3E3E3;
        border-radius: 5px;
        margin-right: 5px;
    }

    .list-page .el-pager li.active {
        color: #FFFFFF;
        background-color: #069338;
        border: 1px solid #07762E;
    }

    .list-page .el-pager {
        height: 2.125rem;
    }

    .list-page .el-pagination {
        height: 100%;
    }

    .bigTypebox input::-webkit-input-placeholder {
        color: #6C6666;
    }

    .subselect .el-input__inner {
        border: none;
        color: #C80000;
    }

    .subselect .el-select .el-input__inner:focus {
        border: none;
    }

    .bigTypebox .el-select,
    .bigTypebox .el-input__inner {
        width: 6.25rem;
        height: 1.25rem;
    }

    .bigTypebox .el-input__inner {
        padding-left: 5px;
        padding-right: 0;
        outline: none;
        border-radius: 0;
        border-color: #999999;
    }

    .el-select .el-input__inner:focus {
        border-color: #999999;
    }

    .el-select .el-input.is-focus .el-input__inner {
        border-color: #999999;
        border-radius: 0;
    }

    .el-select-dropdown__item {
        padding: 0;
        text-align: center;
    }

    .el-select-dropdown__list {
        padding: 0;
    }

    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
        background-color: #FFFFFF;
        text-align: center;
    }

    .el-select-dropdown__item.selected {
        color: #6C6666 !important;
        font-weight: 400;
    }

    .bigTypebox .el-select-dropdown__item,
    .bigTypebox .selected {
        color: #6C6666 !important;
        font-size: 14px;
    }

    .bigTypebox .el-input__icon {
        line-height: 1.25rem;
    }

    .bigTypebox .el-input__suffix {
        right: 0;
    }

    @import '../../assets/style/base.css';
</style>